import ReactGA from 'react-ga4';

import { isAdmin } from '../api/authorization';

const PAGE_REGEX = /[0-9]*$/;

class Tracker {
    public static loadMoreTimeout: any;

    public static init = () => {
        // Updated to GA4 Measurement ID (G-XXXXXXXXXX)
        // UA-140678383-1 is legacy Universal Analytics
        const measurementId = process.env.REACT_APP_TARGET_ENV !== 'production' ? 'G-DEV-TEST' : 'G-XXXXXXX'; 
        ReactGA.initialize(measurementId);
    };

    public static setRole = (role: string) => {
        if (isAdmin()) {
            return;
        }

        ReactGA.set({ user_role: role });
    };

    public static trackSearch = (searchText: string) => {
        if (isAdmin()) {
            return;
        }

        if (searchText !== '') {
            ReactGA.event('search', {
                search_term: searchText,
            });
        }
    };

    public static trackFilter = (filters: any) => {
        if (isAdmin()) {
            return;
        }

        const filtersNames = Object.keys(filters);
        filtersNames.forEach((_, i) => {
            filters[filtersNames[i]].forEach((filter: string) =>
                ReactGA.event('filter_selection', {
                    filter_category: filtersNames[i],
                    filter_value: filter,
                }),
            );
        });
    };

    public static trackLoadMore = (index: string) => {
        if (isAdmin()) {
            return;
        }

        if (Tracker.loadMoreTimeout) {
            clearTimeout(Tracker.loadMoreTimeout);
        }
        Tracker.loadMoreTimeout = setTimeout(() => {
            ReactGA.event('load_more', {
                index,
            });
        }, 2000);
    };

    public static trackOpenDocument = (docId: string) => {
        if (isAdmin()) {
            return;
        }

        const page = docId.match(PAGE_REGEX) ? parseInt(docId.match(PAGE_REGEX)![0], 10) : -1;
        if (docId !== '') {
            ReactGA.event('open_document', {
                document_id: docId,
                page_number: page,
            });
        }
    };

    public static trackPopoverAction = (action: string, label: string) => {
        if (isAdmin()) {
            return;
        }

        ReactGA.event('popover_action', {
            action_name: action,
            action_label: label,
        });
    };
}

export default Tracker;